module.exports = __webpack_public_path__ + "public/images/about-top-title-bg.81b4db8eb18a920682a2efc7f50dccff.svg";